import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Typography, CircularProgress, Button } from "@mui/material";
import { verifyEmail } from "../../services/services";

function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setLoading(false);
      setSuccess(false);
      setMessage("Invalid verification link");
      return;
    }

    verifyEmail(token)
      .then((res: any) => {
        setSuccess(true);
        setMessage(res?.data?.message || "Email verified successfully");
      })
      .catch((error) => {
        setSuccess(false);
        setMessage(error?.response?.data?.message || "Verification failed");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 3,
      }}
    >
      <Box
        sx={{
          maxWidth: 500,
          width: "100%",
          textAlign: "center",
          p: 4,
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        {loading ? (
          <>
            <CircularProgress />
            <Typography mt={2}>Verifying your email...</Typography>
          </>
        ) : (
          <>
            <Typography
              variant="h5"
              color={success ? "success.main" : "error.main"}
              gutterBottom
            >
              {success ? "Email Verified!" : "Verification Failed"}
            </Typography>

            <Typography mb={3}>{message}</Typography>
            {!success ? (
              <Button
                variant="contained"
                onClick={() => navigate("/auth")}
                disabled
              >
                Go to Login
              </Button>
            ) : (
              <Button variant="contained" onClick={() => navigate("/auth")}>
                Go to Login
              </Button>
            )}
          </>
        )}
      </Box>
    </Box>
  );
}

export default VerifyEmail;
